<div id="profileReviewModal" class="modal fade" role="dialog">
    <div class="modal-dialog profile-review">
        <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
                <div class="profile-review__header" *ngIf="!error">
                    <h4 class="modal-title" id="modal-label">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span class="profile-review__header__title">
                            {{profileReviewModalTitle}}
                        </span>
                    </h4>
                    <p class="profile-review__header__sub-title">
                        {{profileReviewModalSubTitle}}
                    </p>
                </div>
            </div>

            <!--Body-->
            <div class="modal-body profile-review__body">
                <div *ngIf="error">
                    <label class="alert alert-danger">
                        Something has gone wrong. Please refresh the page and try again
                    </label>
                </div>
                <div *ngIf="!error">
                    <form id="profileReviewForm" name="profileReviewForm" #profileReviewForm="ngForm">
                        <!--Mobile Number Section-->
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="profile-review__body__mobile-number form-group form-inline"
                                    [ngClass]="{'has-info': mobileNumberInput.dirty && mobileNumberInput.invalid}">
                                    <label class="profile-review__body__mobile-number__label" for="profileMobileNumber">
                                        {{profileReviewModalMobileNumberLabel}}
                                    </label>
                                    <span class="profile-review__body__mobile-number__sub-title help-block sub-title">
                                        {{profileReviewModalMobileNumberSubTitle}}
                                    </span>
                                    <div class="has-feedback">
                                        <div class="lookup-field">
                                            <input class="profile-review__body__mobile-number__textbox form-control"
                                                type="text" name="mobileNumber" id="mobileNumber"
                                                (ngModelChange)="mobileChanged()" [pattern]="mobilePattern"
                                                [(ngModel)]="formData.mobileNumber" #mobileNumberInput="ngModel"
                                                required [minlength]="11" [maxlength]="15" />
                                            <button
                                                class="profile-review__body__mobile-number__send-verify-code-button btn btn-primary"
                                                type="button" name="sendVerifyCodeBtn" id="sendVerifyCodeBtn"
                                                (click)="sendVerificationCode()"
                                                [disabled]="codeSent || mobileNumberInput.invalid || mobileNumberInput.pristine">
                                                {{profileReviewModalSendVerificationCodeButton}}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="mobileNumberInput.invalid">
                                        <div class="col-xs-12">
                                            <span class="help-block has-error">
                                                <span *ngIf="mobileNumberInput.errors">
                                                    <span>{{mobileNumberValidationMessage}}</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--SMS Verify Code Section-->
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="profile-review__body__sms-verify form-group form-inline" *ngIf="codeSent">
                                    <label class="profile-review__body__sms-verify__label" for="smsVerifyCode">
                                        {{profileReviewModalVerificationCodeDescriptionLabel}}
                                    </label>
                                    <span class="profile-review__body__sms-verify__sub-title help-block sub-title">
                                        {{profileReviewModalVerificationCodeSubTitle}}
                                    </span>
                                    <div class="has-feedback">
                                        <div class="lookup-field">
                                            <input class="profile-review__body__sms-verify__verify-button form-control"
                                                type="text" name="smsVerifyCode" id="smsVerifyCode"
                                                (ngModelChange)="verifyCodeChanged()"
                                                [(ngModel)]="formData.smsVerifyCode" />
                                            <i *ngIf="showFailedMessage"
                                                class="profile-review__body__sms-verify__validation-icon fa fa-times-circle-o form-control-feedback"
                                                aria-hidden="true"></i>
                                            <i *ngIf="showVerifiedMessage"
                                                class="profile-review__body__sms-verify__validation-icon fa fa-check-circle-o form-control-feedback"
                                                aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Other Number Section-->
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="profile-review__body__other-number form-group"
                                    [ngClass]="{'has-info': otherNumberInput.dirty && otherNumberInput.invalid}">
                                    <label class="profile-review__body__other-number__label" for="profileOtherNumber">
                                        {{profileReviewModalOtherNumberLabel}}
                                    </label>
                                    <span class="help-block sub-title">
                                        {{profileReviewModalOtherNumberSubTitle}}
                                    </span>
                                    <div class="has-feedback">
                                        <input class="profile-review__body__other-number__textbox form-control"
                                            type="text" name="otherNumber" id="otherNumber"
                                            (ngModelChange)="otherChanged()" [(ngModel)]="formData.otherNumber"
                                            [pattern]="phonePattern" #otherNumberInput="ngModel" [minlength]="11"
                                            [maxlength]="15" />
                                    </div>
                                    <div class="row" *ngIf="otherNumberInput.invalid">
                                        <div class="col-xs-12">
                                            <span class="help-block has-error">
                                                <span *ngIf="otherNumberInput.errors">
                                                    <span>{{otherNumberValidationMessage}}</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Messages Section-->
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="profile-review__body__message">
                                    <div class="has-feedback">
                                        <label class="profile-review__body__message__success alert alert-success"
                                            *ngIf="showVerifiedMessage">
                                            {{profileReviewModalVerificationSuccessMessage}}
                                        </label>
                                        <label class="profile-review__body__message__error alert alert-danger"
                                            *ngIf="showFailedMessage">
                                            {{profileReviewModalVerificationFailedMessage}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!--Footer-->
            <div class="modal-footer">
                <div class="row" *ngIf="!error">
                    <div class="profile-review__footer">
                        <div class="modal-footer profile-review__footer__button-container">
                            <button class="profile-review__footer__button-container__submit btn btn-primary"
                                type="button" (click)="submit()"
                                [disabled]="!codeSent || showVerifiedMessage || mobileNumberInputInvalid">
                                {{profileReviewModalSubmitButton}}
                            </button>
                            <button class="profile-review__footer__button-container__skip-button btn btn-default"
                                type="button" (click)="delayProfileReview()" [disabled]="showVerifiedMessage">
                                {{profileReviewModalSkipButton}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>